var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-select"},[_c('span',[_vm._v("选择图片")]),_c('picture-input',{ref:"pictureInput",attrs:{"width":"600","height":"600","margin":"16","accept":"image/jpeg,image/png, image/jpg","size":"10","button-class":"btn","custom-strings":{
        upload: '<h1>Bummer!</h1>',
        drag: 'Drag a 😺 GIF or GTFO'
      }},on:{"change":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }